import { defineCrestModule } from '@crest/platform-contracts/modules';
import { platformMyDayHostCapability, platformOptionalFactProviderHostCapability, } from '@crest/platform-contracts/hosts';
import { projectsTimeReferenceCapability } from '@crest/module-projects/contracts/time-reference';
import { projectsTimeLocationReferenceCapability } from '@crest/module-projects/contracts/time-location-reference';
import { projectsImportResolutionCapability } from '@crest/module-projects/contracts/import-resolution';
import { platformImportResolutionCapability } from '@crest/platform-contracts/import-resolution';
import { timesheetsLocationEvidenceCapability } from './contracts/timesheets-location-evidence.contract.js';
import { timesheetsCurrentProjectSuggestionCapability } from './contracts/timesheets-clock.contract.js';
import { timesheetsEntrySplitCapability } from './contracts/timesheets-entry-split.contract.js';
import { timesheetsActivityReviewHostCapability } from './contracts/timesheets-activity-review-host.contract.js';
import { timesheetsInsuranceClaimsReadinessProviderId, timesheetsProjectLaborSummaryCapability, } from './contracts/timesheets-insurance-claims-readiness.contract.js';
import { timesheetsFinanceProfitabilityLaborCapability, timesheetsFinanceProfitabilityLaborProviderId, } from './contracts/timesheets-finance-profitability-labor.contract.js';
import { timesheetsAssistantContextCapability, timesheetsAssistantContextProviderId, } from './contracts/timesheets-assistant-context.contract.js';
import { timesheetsTimeEntryImportCapability } from './import/timesheets-time-entry-import.contract.js';
export const timesheetsModuleManifest = defineCrestModule({
    id: 'timesheets',
    version: '1.0.0',
    kind: 'business',
    required: false,
    requires: ['platform', 'projects'],
    requiredCapabilities: [
        'platform.tenant-context.v1',
        'platform.module-access.v1',
        'platform.membership-directory.v1',
        projectsTimeReferenceCapability,
        projectsTimeLocationReferenceCapability,
        platformImportResolutionCapability,
        projectsImportResolutionCapability,
        platformMyDayHostCapability,
        platformOptionalFactProviderHostCapability,
    ],
    optionalCapabilities: [],
    optionalCapabilityFallbacks: [],
    provides: [
        'timesheets.clock.v1',
        timesheetsCurrentProjectSuggestionCapability,
        'timesheets.entries.v1',
        'timesheets.breaks.v1',
        'timesheets.review.v1',
        'timesheets.corrections.v1',
        'timesheets.lunch-compliance.v1',
        'timesheets.lunch-corrections.v1',
        'timesheets.missing-lunch-reports.v1',
        'timesheets.pay-policy.v1',
        'timesheets.pay-snapshots.v1',
        'timesheets.payroll-cost-summary.v1',
        'timesheets.mileage.v1',
        'timesheets.crew-allocation.v1',
        timesheetsEntrySplitCapability,
        timesheetsLocationEvidenceCapability,
        timesheetsProjectLaborSummaryCapability,
        timesheetsFinanceProfitabilityLaborCapability,
        timesheetsActivityReviewHostCapability,
        timesheetsAssistantContextCapability,
        timesheetsTimeEntryImportCapability,
    ],
    permissions: [
        'timesheets.clock.read-own',
        'timesheets.clock.use',
        'timesheets.entries.read-all',
        'timesheets.entries.create-manual',
        'timesheets.entries.correct',
        'timesheets.entries.review',
        'timesheets.entries.void',
        'timesheets.entries.split',
        'timesheets.lunch-corrections.request-own',
        'timesheets.lunch-corrections.read-all',
        'timesheets.lunch-corrections.review',
        'timesheets.lunch-reports.read',
        'timesheets.lunch-reports.queue',
        'timesheets.pay-rates.read',
        'timesheets.pay-rates.manage',
        'timesheets.payroll.view-costs',
        'timesheets.mileage.read-own',
        'timesheets.mileage.use-own',
        'timesheets.mileage.read-all',
        'timesheets.mileage.adjust',
        'timesheets.crew.read-own',
        'timesheets.crew.use-own',
        'timesheets.crew.read-all',
        'timesheets.crew.manage',
        'timesheets.location.read-own',
        'timesheets.location.capture-own',
        'timesheets.location.read-all',
        'timesheets.location.review',
        'timesheets.location.manage',
        'timesheets.import.read',
        'timesheets.import.execute',
        'timesheets.import.rollback',
    ],
    settings: [
        'timesheets.workday.policy',
        'timesheets.payroll.policy',
        'timesheets.clock.display',
        'timesheets.activity-review.display',
        'timesheets.copy.clock',
        'timesheets.copy.my-day',
        'timesheets.copy.activity-review',
        'timesheets.copy.lunch-review',
        'timesheets.copy.crew-allocation',
        'timesheets.copy.location-review',
        'timesheets.copy.entry-split',
    ],
    copyCatalogs: [
        'timesheets.copy.clock',
        'timesheets.copy.my-day',
        'timesheets.copy.activity-review',
        'timesheets.copy.lunch-review',
        'timesheets.copy.crew-allocation',
        'timesheets.copy.location-review',
        'timesheets.copy.entry-split',
    ],
    events: {
        publishes: [
            'timesheets.clock-started.v1',
            'timesheets.clock-stopped.v1',
            'timesheets.clock-entry-needs-correction.v1',
            'timesheets.break-started.v1',
            'timesheets.break-ended.v1',
            'timesheets.entry-created-manual.v1',
            'timesheets.entry-corrected.v1',
            'timesheets.entry-reviewed.v1',
            'timesheets.entry-voided.v1',
            'timesheets.entry-split.v1',
            'timesheets.lunch-correction-requested.v1',
            'timesheets.lunch-correction-reviewed.v1',
            'timesheets.missing-lunch-report-ready.v1',
            'timesheets.pay-rate-version-created.v1',
            'timesheets.entry-pay-snapshot-captured.v1',
            'timesheets.mileage-opt-in-changed.v1',
            'timesheets.mileage-point-recorded.v1',
            'timesheets.mileage-adjusted.v1',
            'timesheets.crew-assignment-requested.v1',
            'timesheets.crew-assignment-manager-overridden.v1',
            'timesheets.crew-assignment-confirmed.v1',
            'timesheets.crew-assignment-rejected.v1',
            'timesheets.crew-assignment-ended.v1',
            'timesheets.crew-allocation-synchronized.v1',
            'timesheets.location-device-registered.v1',
            'timesheets.location-device-revoked.v1',
            'timesheets.managed-place-created.v1',
            'timesheets.managed-place-updated.v1',
            'timesheets.location-point-recorded.v1',
            'timesheets.location-visit-candidate-created.v1',
            'timesheets.location-point-reviewed.v1',
            'timesheets.location-visit-reviewed.v1',
            'timesheets.lunch-correction-requested.v2',
            'timesheets.missing-lunch-report-ready.v2',
        ],
        subscribes: [],
    },
    server: {
        routes: [
            { id: 'timesheets.routes.clock', priority: 0 },
            { id: 'timesheets.routes.current-project-suggestion', priority: 5 },
            { id: 'timesheets.routes.entries', priority: 10 },
            { id: 'timesheets.routes.lunch-compliance', priority: 20 },
            { id: 'timesheets.routes.payroll-cost-summary', priority: 30 },
            { id: 'timesheets.routes.mileage', priority: 40 },
            { id: 'timesheets.routes.crew-allocation', priority: 50 },
            { id: 'timesheets.routes.location-evidence', priority: 60 },
        ],
        jobs: [],
        subscribers: [],
        slots: [{
                id: timesheetsInsuranceClaimsReadinessProviderId,
                requiredCapability: platformOptionalFactProviderHostCapability,
                requiredPermission: 'timesheets.entries.read-all',
                priority: 0,
            }, {
                id: timesheetsFinanceProfitabilityLaborProviderId,
                requiredCapability: platformOptionalFactProviderHostCapability,
                requiredPermission: 'timesheets.payroll.view-costs',
                priority: 10,
            }, {
                id: timesheetsAssistantContextProviderId,
                requiredCapability: platformOptionalFactProviderHostCapability,
                priority: 20,
            }],
    },
    web: {
        routes: [
            { id: 'timesheets.web.clock', priority: 0 },
            {
                id: 'timesheets.web.activity-review',
                requiredPermission: 'timesheets.entries.read-all',
                priority: 5,
            },
            {
                id: 'timesheets.web.lunch-review',
                requiredPermission: 'timesheets.lunch-corrections.read-all',
                priority: 10,
            },
            {
                id: 'timesheets.web.location-review',
                requiredPermission: 'timesheets.location.read-all',
                priority: 20,
            },
            {
                id: 'timesheets.web.entry-split',
                requiredPermission: 'timesheets.entries.split',
                priority: 30,
            },
            {
                id: 'timesheets.web.lunch-correction-review-target',
                requiredPermission: 'timesheets.lunch-corrections.read-all',
                priority: 40,
            },
            {
                id: 'timesheets.web.missing-lunch-report-target',
                requiredPermission: 'timesheets.lunch-reports.read',
                priority: 50,
            },
        ],
        navigation: [
            { id: 'timesheets.navigation.clock', priority: 30 },
            {
                id: 'timesheets.navigation.activity-review',
                requiredPermission: 'timesheets.entries.read-all',
                priority: 31,
            },
            {
                id: 'timesheets.navigation.lunch-review',
                requiredPermission: 'timesheets.lunch-corrections.read-all',
                priority: 32,
            },
            {
                id: 'timesheets.navigation.location-review',
                requiredPermission: 'timesheets.location.read-all',
                priority: 33,
            },
            {
                id: 'timesheets.navigation.entry-split',
                requiredPermission: 'timesheets.entries.split',
                priority: 34,
            },
        ],
        slots: [{
                id: 'timesheets.web.platform.my-day',
                requiredCapability: platformMyDayHostCapability,
                requiredPermission: 'timesheets.clock.read-own',
                priority: 10,
            }],
    },
    mobile: { routes: [], slots: [] },
    portal: { routes: [], slots: [] },
    database: {
        schema: 'timesheets',
        owns: [
            'timesheets.time_entries',
            'timesheets.entry_corrections',
            'timesheets.lunch_correction_requests',
            'timesheets.missing_lunch_report_runs',
            'timesheets.membership_pay_rate_versions',
            'timesheets.entry_pay_snapshots',
            'timesheets.entry_split_commands',
            'timesheets.entry_split_segments',
            'timesheets.split_entry',
            'timesheets.read_payroll_cost_projection',
            'timesheets.mileage_days',
            'timesheets.mileage_day_transitions',
            'timesheets.mileage_points',
            'timesheets.mileage_basis_snapshots',
            'timesheets.mileage_adjustments',
            'timesheets.coordinate_distance_millimiles',
            'timesheets.capture_mileage_basis_snapshot',
            'timesheets.set_own_mileage_day',
            'timesheets.record_own_mileage_point',
            'timesheets.adjust_mileage_day',
            'timesheets.crew_assignments',
            'timesheets.crew_allocation_commands',
            'timesheets.crew_allocation_transitions',
            'timesheets.capture_entry_pay_snapshot_core',
            'timesheets.sync_crew_assignment_allocation',
            'timesheets.request_crew_assignment',
            'timesheets.respond_crew_assignment',
            'timesheets.end_crew_assignment',
            'timesheets.sync_crew_allocations_for_membership',
            'timesheets.end_crew_allocations_at_clock_boundary',
            'timesheets.location_commands',
            'timesheets.location_devices',
            'timesheets.managed_places',
            'timesheets.location_points',
            'timesheets.location_point_reviews',
            'timesheets.location_visit_candidates',
            'timesheets.location_visit_reviews',
            'timesheets.coordinate_distance_millimeters',
            'timesheets.register_own_location_device',
            'timesheets.revoke_own_location_device',
            'timesheets.create_managed_place',
            'timesheets.update_managed_place',
            'timesheets.review_location_point',
            'timesheets.review_location_visit_candidate',
            'timesheets.record_own_location_point',
            'timesheets.time_entry_import_runs',
            'timesheets.time_entry_import_identity_map',
            'timesheets.time_entry_import_receipts',
            'timesheets.time_entry_import_rejects',
            'timesheets.time_entry_import_rollbacks',
            'timesheets.time_entry_import_canonical_json',
            'timesheets.time_entry_import_sha256',
            'timesheets.time_entry_import_payload_keys',
            'timesheets.time_entry_import_deterministic_id',
            'timesheets.time_entry_import_command_id',
            'timesheets.time_entry_import_target_canonical',
            'timesheets.time_entry_import_receipt_json',
            'timesheets.time_entry_import_authorized',
            'timesheets.time_entry_import_assert_membership_resolution',
            'timesheets.time_entry_import_assert_project_resolution',
            'timesheets.begin_time_entry_import_v1',
            'timesheets.load_time_entry_import_run_v1',
            'timesheets.record_time_entry_import_reject_v1',
            'timesheets.apply_time_entry_import_row_v1',
            'timesheets.rollback_time_entry_import_row_v1',
            'timesheets.complete_time_entry_import_v1',
            'timesheets.fail_time_entry_import_v1',
            'timesheets.mark_time_entry_import_rolled_back_v1',
            'timesheets.apply_mileage_import_v1',
        ],
        readsThrough: [
            projectsTimeReferenceCapability,
            projectsTimeLocationReferenceCapability,
            platformImportResolutionCapability,
            projectsImportResolutionCapability,
        ],
        migrations: [
            'timesheets.clock_foundation',
            'timesheets.entries_breaks_review',
            'timesheets.missing_lunch_compliance',
            'timesheets.payroll_policy_snapshots',
            'timesheets.payroll_cost_summary_projection',
            'timesheets.mileage_foundation',
            'timesheets.crew_allocation',
            'timesheets.entry_split',
            'timesheets.location_evidence',
            'timesheets.location_project_matching',
            'timesheets.time_entry_import',
            'timesheets.time_entry_import_dynamic_source_count',
            'timesheets.operational_history_import',
        ],
    },
    health: ['timesheets.database'],
    lifecycle: {
        initialization: { timeoutMs: 5_000, failureBehavior: 'quarantine-module' },
        resources: {
            requestConcurrency: 96,
            jobConcurrency: 0,
            queueBacklogLimit: 0,
            databaseConnectionBudget: 12,
            workerIsolation: 'shared-api',
        },
        disable: {
            data: 'retain',
            clientContributions: 'remove',
            serverRoutes: 'deny-tenant-access',
            scheduledJobs: 'skip',
            events: {
                behavior: 'drop-safe',
                durableCursor: false,
                retentionDays: 0,
                backlogLimit: 0,
                warningAt: 0,
                reconciliationProcedure: null,
                dropSafeReason: 'The current Timesheets slice publishes facts but owns no inbound event subscriber.',
            },
            outboundSideEffects: 'suppress-no-retroactive-send',
            inFlight: 'finish-idempotently',
        },
        resume: {
            configuration: 'last-compatible-published',
            healthChecks: ['timesheets.database'],
            reconciliationProcedure: null,
            visibility: 'after-health-and-reconciliation',
        },
        uninstall: {
            executableCode: 'remove',
            data: 'retain',
            tombstone: 'retain-immutable',
            destruction: 'separate-explicit-authority',
        },
    },
    retentionPolicy: 'Timesheet records remain stored and inaccessible while the optional module is disabled.',
});
//# sourceMappingURL=timesheets.module.js.map